export function validatePhoneNumber(phoneNumber: string) {
  const re = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
  return re.test(phoneNumber)
}
export function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
export function validatePassword(password: string) {
  const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
  return re.test(password)
}
export function validateMinLength(minLength: number, APIName: string) {
  return APIName.length >= minLength
}

export function validateName(name: string) {
  const re = /^[a-z ,.'-]{1,}$/i
  return re.test(name)
}

export function checkMvxAddress(address: string) {
  return address?.trim()?.startsWith('erd') && address?.trim()?.length === 62
}

export function checkEthAddress(address: string) {
  return address?.trim()?.startsWith('0x') && address?.trim()?.length === 42
}
